var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.data),function(item){return _c('a',{key:item.id,on:{"click":function($event){return _vm.onClick(item)}}},[_vm._v(_vm._s(item.name)+";")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }